import React, { useEffect } from 'react';
import { Routes, Route, useLocation, useNavigate} from 'react-router-dom';
import Layout from './Layout';
import Home from './Page/Home';
import Client from './Page/client/Client';
import Societe from './Page/societe/Societe';
import Contact from './Page/Contact';
import InscriptionClient from './Page/Auth/InscriptionClient';
import LoginClient from './Page/Auth/LoginClient';
import LoginRestaurant from './Page/Auth/LoginRestaurant';
import LoginSociete from './Page/Auth/LoginSociete';
import Restaurant from './Page/Restaurant';
import ResetPasswordRestaurant from './Page/Auth/ResetPasswordRestaurant';
import RestaurantLayout from './Page/restaurant/RestaurantLayout';
import SearchSansCritere from './Page/SearchSansCritere';
import SearchCritere from './Page/SearchCritere';
import NotFoundPage from './Page/NotFoundPage';
import Marche from './Page/Marche';
import RestoPage from './Page/RestoPage';
import FinalReservation from './Page/FinalReservation';
import Confirmation from './Page/Confirmation';
import Annulation from './Page/Annulation';
import DepotAvis1 from './Page/DepotAvis1';
import DepotAvis2 from './Page/DepotAvis2';
import ReserverSansCritere from './Page/ReserverSansCritere';


import ProfileResto from './Page/restaurant/ProfileResto';
import CarteMenu from './Page/restaurant/CarteMenu';
import Menus from './Page/restaurant/Menus';
import Promotion from './Page/restaurant/Promotion';
import Information from './Page/restaurant/Information';
import OffrePromo from './Page/restaurant/OffrePromo';
import RestaurantAvis from './Page/restaurant/Avis';
import Reservation from './Page/restaurant/Reservation';
import ResaAnnuelle from './Page/restaurant/ResaAnnuelle';
import ResaMensuelle from './Page/restaurant/ResaMensuelle';
import ResaHebdomadaire from './Page/restaurant/ResaHebdomadaire';
import ResaJourrnalier from './Page/restaurant/ResaJournalier';
import Creneau from './Page/restaurant/Creneau';
import PrendreReservation from './Page/restaurant/PrendreReservation';
import Analitics from './Page/restaurant/Analitics';
import Marketing from './Page/restaurant/Marketing';
import RestaurantContact from './Page/restaurant/Contact';
import RestaurantAide from './Page/restaurant/Aide';


import Donner from './Page/client/Donner';
import Historique from './Page/client/Historique';
import Favoris from './Page/client/Favoris';
import ClientAvis from './Page/client/Avis';
import Fideliter from './Page/client/Fideliter';
import Abonnement from './Page/client/Abonnement';
import ClientContact from './Page/client/Contact';
import ClientAide from './Page/client/Aide';




import ParametragePage from './Page/societe/ParametragePage';
import GererRestaurant from './Page/societe/GererRestaurant';
import GererClient from './Page/societe/GererClient';
import GererAvis from './Page/societe/GererAvis';

import db from './db';


const Navigation = () => {

  let location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/client") {
      navigate("/client/donner")
    }
  }, [location, navigate]);

  useEffect(() => {
    if (!localStorage.getItem('tokenRestaurant') &&
      (
        location.pathname === "/adminRestaurant/presentation" ||
        location.pathname === "/adminRestaurant/carte" ||
        location.pathname === "/adminRestaurant/menue" ||
        location.pathname === "/adminRestaurant/promotion" ||
        location.pathname === "/adminRestaurant/information" ||
        location.pathname === "/adminRestaurant/offrePromo" ||
        location.pathname === "/adminRestaurant/avis" ||
        location.pathname === "/adminRestaurant/reservation" ||
        location.pathname === "/adminRestaurant/resaAnnuelle" ||
        location.pathname === "/adminRestaurant/resaMensuelle" ||
        location.pathname === "/adminRestaurant/resaHebdomadaire" ||
        location.pathname === "/adminRestaurant/resaJournalier" ||
        location.pathname === "/adminRestaurant/creneau" ||
        location.pathname === "/adminRestaurant/prendreReservation" ||
        location.pathname === "/adminRestaurant/analitics" ||
        location.pathname === "/adminRestaurant/marketing" ||
        location.pathname === "/adminRestaurant/contact" ||
        location.pathname === "/adminRestaurant/aide"
      )) {
      navigate("/loginRestaurant");
    }

    if (!localStorage.getItem('tokenSociete') &&
      (location.pathname === "/societe" ||
        location.pathname === "/societe/parametrage" ||
        location.pathname === "/societe/gererRestaurant" ||
        location.pathname === "/societe/gererClient" ||
        location.pathname === "/societe/gererAvis"
      )) {
      navigate("/adminSociete");
    }




    if (!localStorage.getItem('tokenClient') &&
      (location.pathname === "/client" ||
        location.pathname === "/client/donner" ||
        location.pathname === "/client/historique" ||
        location.pathname === "/client/favoris" ||
        location.pathname === "/client/avis" ||
        location.pathname === "/client/fideliter" ||
        location.pathname === "/client/abonnement" ||
        location.pathname === "/client/contact" ||
        location.pathname === "/client/aide"
      )) {
      navigate("/loginClient");
    }


  }, [location.pathname, navigate]);

  useEffect(() => {
    if (localStorage.getItem('tokenRestaurant') && (location.pathname === "/loginRestaurant" || location.pathname === "/resetRestaurant/:token" || location.pathname === "/adminRestaurant")) {
      navigate("/adminRestaurant/presentation");
    }
    if (localStorage.getItem('tokenSociete') && (location.pathname === "/societe" || location.pathname === "/adminSociete")) {
      navigate("/societe/parametrage");
    }
    if (localStorage.getItem('tokenClient') && (location.pathname === "/inscriptionClient" || location.pathname === "/loginClient")) {
      navigate("/client/donner");
    }
  }, [location.pathname, navigate])

  useEffect(() => {
    const fetchAndSetData = async()=> {
      try {
        const donner = await db.monTableau.toArray();
        if (donner.length === 0 && (location.pathname === "/restaurant" || location.pathname === "/restaurant/..." || location.pathname === "/restaurant/:ou" ||
        location.pathname === "/restaurant/:ou/:qoui" || location.pathname === "/restaurant/:ou/:date/:heure/:personne" || location.pathname === "/restaurant/:ou/:qoui/:date/:heure/:personne" ||
        location.pathname === "/restoPage" || location.pathname === "/restoPage/:idRestaurant" || location.pathname === "/reserverSansCritere/:idRestaurant" ||
        location.pathname === "/finaliserReservation" || location.pathname === "/finaliserReservation" || location.pathname === "/confirmation"  || location.pathname === "/annulation"
        )) {
          navigate("/");
        }
      } catch (error) {
        console.error('Erreur lors de la récupération des données depuis Dexie :', error);
      }
    };
    fetchAndSetData();
  }, [location.pathname, navigate])


  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route index element={<Home />} />
        <Route path='contact' element={<Contact />} />
        <Route path='*' element={<NotFoundPage />} />
        <Route path='inscriptionClient' element={<InscriptionClient />} />
        <Route path='marche' element={<Marche />} />
        <Route path='loginClient' element={<LoginClient />} />
        <Route path='loginRestaurant' element={<LoginRestaurant />} />
        <Route path='resetRestaurant/:token' element={<ResetPasswordRestaurant />} />
        <Route path='adminSociete' element={<LoginSociete />} />
        <Route path='restaurant' element={<Restaurant />} />
        <Route path='restaurant/...' element={<Restaurant />} />
        <Route path='restaurant/:ou' element={<SearchSansCritere />} />
        <Route path='restaurant/:ou/:qoui' element={<SearchSansCritere />} />
        <Route path='restaurant/:ou/:date/:heure/:personne' element={<SearchCritere />} />
        <Route path='restaurant/:ou/:qoui/:date/:heure/:personne' element={<SearchCritere />} />
        <Route path='restoPage' element={<Restaurant />} />
        <Route path='restoPage/:idRestaurant' element={<RestoPage />} />
        <Route path='finaliserReservation' element={<FinalReservation />} />
        <Route path='confirmation' element={<Confirmation />} />
        <Route path='annulation' element={<Annulation />} />
        <Route path='depotAvisRestaurant/:nomRestaurant/:adresse/:idRestaurant/:jour/:heure/:personne/:idReservation/:idClient' element={<DepotAvis1 />} />
        <Route path='depotAvisProduit' element={<DepotAvis2 />} />
        <Route path='reserverSansCritere/:idRestaurant' element={<ReserverSansCritere />} />
        <Route path='client' element={<Client />}>
          <Route path='donner' element={<Donner />} />
          <Route path='historique' element={<Historique />} />
          <Route path='favoris' element={<Favoris />} />
          <Route path='avis' element={<ClientAvis />} />
          <Route path='fideliter' element={<Fideliter />} />
          <Route path='abonnement' element={<Abonnement />} />
          <Route path='contact' element={<ClientContact />} />
          <Route path='aide' element={<ClientAide />} />
        </Route>
        <Route path='adminRestaurant' element={<RestaurantLayout />}>
          <Route path='presentation' element={<ProfileResto />} />
          <Route path='carte' element={<CarteMenu />} />
          <Route path='menue' element={<Menus />} />
          <Route path='promotion' element={<Promotion />} />
          <Route path='information' element={<Information />} />
          <Route path='offrePromo' element={<OffrePromo />} />
          <Route path='avis' element={<RestaurantAvis />} />
          <Route path='reservation' element={<Reservation />} />
          <Route path='resaAnnuelle' element={<ResaAnnuelle />} />
          <Route path='resaMensuelle' element={<ResaMensuelle />} />
          <Route path='resaHebdomadaire' element={<ResaHebdomadaire />} />
          <Route path='resaJournalier' element={<ResaJourrnalier />} />
          <Route path='creneau' element={<Creneau />} />
          <Route path='prendreReservation' element={<PrendreReservation />} />
          <Route path='analitics' element={<Analitics />} />
          <Route path='marketing' element={<Marketing />} />
          <Route path='contact' element={<RestaurantContact />} />
          <Route path='aide' element={<RestaurantAide />} />
        </Route>
        <Route path='societe' element={<Societe />}>
          <Route path='parametrage' element={<ParametragePage />} />
          <Route path='gererRestaurant' element={<GererRestaurant />} />
          <Route path='gererClient' element={<GererClient />} />
          <Route path='gererAvis' element={<GererAvis />} />
        </Route>
      </Route>
    </Routes>
  )
}

export default Navigation